<!-- =========================================================================================
  File Name:
  Description:
  ----------------------------------------------------------------------------------------
  Item Name: GetBoarded UI Template
  Author: GetBoarded
  Author URL: https://www.getboarded.com
========================================================================================== -->

<template>
  <div id="page-user-list">
    <!-- Add User and Send Invite -->
    <div class="demo-alignment">
      <vs-button class="primary"   @click="showPopup()" type="filled"
        >{{$t('adduser.title')}}</vs-button
      >
    </div>
<!--    </div><div class="demo-alignment"  @click="activePrompt2">-->
<!--      <vs-button class="primary"  type="filled"-->
<!--        >{{$t('adduser')}}</vs-button-->
<!--      >-->
<!--    </div>-->

    <!-- Add User Prompt -->
    <vs-prompt
      :title="$t('adduser.title')"
      :accept-text="$t('adduser.btn0')"
      :cancel-text="$t('Cancel')"
      @cancel="clearFields"
      @accept="sendInvite"
      @close="clearFields"
      :is-valid="validateEmail && company !== null"
      :active.sync="activePrompt"

    >

        <form @submit.prevent>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>{{$t('adduser.lbl0')}}</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <div class="grid-layout-container alignment-block">
                <vs-row
                  vs-align="flex-end"
                  vs-type="flex"
                  vs-justify=""
                  vs-w="12"
                >
                  <vs-col vs-type="flex" vs-justify="" vs-align="" vs-w="4">
                    <vs-radio v-model="user_type" vs-value="coach"
                      >{{$t('Coach')}}</vs-radio
                    >
                  </vs-col>

                </vs-row>
              </div>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <div class="grid-layout-container alignment-block">
                <vs-row
                  vs-align="flex-end"
                  vs-type="flex"
                  vs-justify=""
                  vs-w="12"
                >

                  <vs-col vs-type="flex" vs-justify=""  class="ml-4" vs-align="" vs-w="4">
                    <vs-radio v-model="user_type" vs-value="trainee"
                    >{{$t('Coachee')}}</vs-radio
                    >
                  </vs-col>
                </vs-row>
              </div>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col sm:w-1/3 w-full">
              <span>{{$t('adduser.lbl1')}}</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-input
                v-validate="'required|min:3'"
                name="FirstName"
                v-model="FirstName"
                class="w-full mb-6"
                :danger="!validateFirstName && FirstName !== ''"
                val-icon-danger="clear"
                :success="validateFirstName"
                val-icon-success="done"
                :color="validateFirstName ? 'success' : 'danger'"
                type="FirstName"
                icon-pack="feather"
                icon="icon-edit"
                icon-no-border
              />

            </div>
          </div> <div class="vx-row">

            <div class="vx-col sm:w-1/3 w-full">
              <span>{{$t('adduser.lbl2')}}</span>
            </div>
            <div class="vx-col sm:w-2/3  w-full">
              <vs-input
                v-validate="'required|min:3'"
                name="LastName"
                v-model="LastName"
                class="w-full mb-6"
                :danger="!validateLastName && LastName !== ''"
                val-icon-danger="clear"
                :success="validateLastName"
                val-icon-success="done"
                :color="validateLastName ? 'success' : 'danger'"
                type="LastName"
                icon-pack="feather"
                icon="icon-edit"
                icon-no-border
              />

            </div>
          </div> <div class="vx-row">

            <div class="vx-col sm:w-1/3 w-full">
              <span>{{$t('adduser.lbl3')}}</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-input
                v-validate="'required|email'"
                name="user_email"
                v-model="user_email"
                class="w-full mb-6"
                :danger="!validateEmail && user_email !== ''"
                val-icon-danger="clear"
                :success="validateEmail"
                val-icon-success="done"
                :color="validateEmail ? 'success' : 'danger'"
                type="email"
                icon-pack="feather"
                icon="icon-mail"
                icon-no-border
              />

            </div>
          </div>
          <div class="vx-row mb-base">
            <div class="vx-col sm:w-1/3 w-full">
              <span>{{$t('adduser.lbl4')}}</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full" v-if="company_list.length===1">
              <component
                  :is="scrollbarTag"
                  class="scroll-area p-4"
                  :settings="settings"
                  :key="$vs.rtl"
              >
              <v-select v-validate="'required'" v-model="company" label="name" :options="company_list"></v-select>
              </component>
            </div>
            <div class="vx-col sm:w-2/3 w-full" v-else>
              <component
                  :is="scrollbarTag"
                  class="scroll-area p-4"
                  :settings="settings"
                  :key="$vs.rtl"
              >
              <v-select v-validate="'required'" v-model="company" label="name" :options="company_list"></v-select>
              </component>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>{{$t('adduser.lbl5')}}</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <div class="grid-layout-container alignment-block">
                <vs-row
                  vs-align="flex-end"
                  vs-type="flex"
                  vs-justify=""
                  vs-w="12"
                >
                  <vs-switch color="success" v-model="lang"  name="lang" >
                    <span slot="on">SP</span>
                    <span slot="off">EN</span>
                  </vs-switch>
                </vs-row>
              </div>
            </div>
          </div>

        </form>

    </vs-prompt>
    <vs-popup :title="$t('requestAccess.popupTitle')" :active.sync="activePrompt2" >
      <div class="con-exemple-prompt">
        <div class="con-exemple-prompt">
          {{$t('requestAccess.popupText1')}}<br>

          <p class="mt-6 float-left">
            {{$t('requestAccess.popupText2')}}</p>
          <vs-button
            href="request-access"
            class="ml-4 mt-4 float-left"
          >{{$t('RequestAccess')}}</vs-button>

        </div>

      </div>
    </vs-popup>

  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { models } from "feathers-vuex";
import vSelect from 'vue-select';
import i18n from "@/i18n/i18n";
import "vue-select/dist/vue-select.css";

export default {
  name: "SendInvite",
  components: {
    VuePerfectScrollbar,
    vSelect
  },
  data () {
    return {
      user_type: "coach",
      FirstName:"",
      LastName:"",
      user_email: "",
      terminology_type:false,
      company: null,
      lang:"",
      company_list: [],
      enterpriseStatus:null,
      activePrompt: false,
      activePrompt2:false,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.3
      }
    };
  },
  watch: {},
  computed: {
    validateEmail () {
      return !this.errors.any() && this.user_email !== "";
    },
    validateFirstName () {
      return !this.errors.any() && this.FirstName !== "";
    },
    validateLastName () {
      return !this.errors.any() && this.LastName !== "";
    },
    scrollbarTag () {
      return this.$store.getters.scrollbarTag;
    }
  },
  methods: {
    showPopup(){
      if(window.$cookies.get('enterpriseType')){
        // this.enterpriseStatus=window.$cookies.get('enterpriseType');
        if(window.$cookies.get('enterpriseType')==="1") {
          this.activePrompt = true;
          this.activePrompt2 = false;
        }
        else{
          this.activePrompt2=true;
          this.activePrompt=false;
        }
        // console.log('enterpriseStatus',this.enterpriseStatus);
      }else{
        this.activePrompt = true;
        this.activePrompt2 = false;
      }
    },
    clearFields () {
      this.$nextTick(() => {
        this.user_email = "";
      });
    },
    sendInvite () {
      console.log('lang status', this.lang)
      if(this.lang===true){
        this.lang='es'
      }else{
         this.lang='en'
      }

      const user = {
        email: this.user_email,
        userType: this.user_type,
        firstName:this.FirstName,
        lastName:this.LastName,
        status: "deactivated",
        emailVerified: 0,
        orgName:this.company.name,
        companyId: this.company.id,
        lang: this.lang
      };
     // console.log('Language',window.$cookies.get('locale'));

      console.log('model', user)

      this.$store
        .dispatch("userManagement/addUser", user)
        .then(res => {
          console.log("going to create user", res);
          this.$vs.notify({
            title: i18n.t('notification.admin.user.add.success.a1'),
            text:  i18n.t('notification.admin.user.add.success.a2'),
            color: "primary"
          });
          window.location.reload();
        })
        .catch(err => {
          console.log("user create failed", err);
          this.$vs.notify({
            title: i18n.t('notification.admin.user.add.error.a1'),
            text:  i18n.t('notification.admin.user.add.error.a2'),
            color: "danger"
          });
        });

    }
  },
  mounted () {
   let query;
    if(window.$cookies.get('companyId')){
      query={
        query:{id:window.$cookies.get('companyId')}
      }
    }
    else{
      query={};
    }
    this.$store.dispatch("companyManagement/fetchCompanies",query).then(res => {
      this.company_list = res.data
      console.log("company list", this.company_list)
    }).catch(err => {
      console.log("could not find companies", err)
    })
  },

};
</script>

<style lang="scss">
.scroll-area {
  position: absolute;
  margin: auto;
  width: 250px;
  height: 100%;
  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>
